module.exports = __webpack_public_path__ + "img/logo_white_shadow.d24538f2.png";